import React from "react";
import MainLayout from "../../components/main-layout";
import FinanceInventoryProvider from "./data-handling/finance-inventory-provider";
import HeaderComponent from "../../layouts/header";
import history from "../../history";
import MainView from "./containers/main-view";
import { Route, Routes } from "react-router-dom";
import { INVENTORY_ACTIVITY_NESTED_ROUTES } from "./data-handling/finance-inventory-constants";
import ActivityEditScreen from "./containers/activity-edit-screen";
import { isSourcePos } from "../../helpers/common-helper";

function FinanceInventoryModule() {
  return (
    <MainLayout activeTabIndex={8} containerClass={`${isSourcePos() ? "!pt-[1px]" : ""}`}>
      {!isSourcePos() && <HeaderComponent
        headingText={"Activity"}
        showBackBtn={true}
        onBackBtnClick={() => history.back()}
      ></HeaderComponent>}
      <FinanceInventoryProvider>
        <Routes>
          <Route
            path={INVENTORY_ACTIVITY_NESTED_ROUTES.root}
            element={<MainView />}
          />
          <Route
            path={INVENTORY_ACTIVITY_NESTED_ROUTES.activityEdit}
            element={<ActivityEditScreen />}
          />
        </Routes>
      </FinanceInventoryProvider>
    </MainLayout>
  );
}

export default FinanceInventoryModule;
